export default __webpack_public_path__ + "static/media/testlibrary.aef9cca0.jpg";